import React, { useState, useRef, useEffect, useMemo } from "react";
import { MotionButton } from "../components/Core/MotionStrap";
import Datatable from "components/Core/DataTable";
import Inventory from "lib/Core/Backend/Controllers/Inventory";
import Brand from "lib/Core/Backend/Controllers/Brand";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  FormGroup,
  Form,
  CustomInput,
  Input,
} from "reactstrap";
import Spinner from 'react-bootstrap/Spinner';
import Notify from "lib/Utils/Alert";
import Select from "react-select";
import NotificationAlert from "react-notification-alert";


const ThresholdInventory = (props) => {
  const { token, accessRoles } = props;
  const [thresholdValue, setThresholdValue] = useState();
  const [currency, setCurrency] = useState("");
  const [currencyId, setCurrencyId] = useState();
  const [brandId, setBrandId] = useState();
  const [brandName, setBrandName] = useState();
  const [cardsLoading, setCardsLoading] = useState(true);
  const [isThresholdModal, setIsThresholdModal] = useState(false);
  const [editThresholdModal, setEditThresholdModal] = useState(false);
  const [cardTypes, setCardTypes] = useState([]);
  const [brandOption, setBrandOption] = useState([]);
  const [cardTypeId, setCardTypeId] = useState();
  const [cardTypeName, setCardTypeName] = useState("");
  const [brandValue, setBrandValue] = useState({});
  const [giftCardValue, setGiftCardValue] = useState({});
  const [allBrandData, setAllBrandData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [confirmModal,setConfirmModal] = useState(false)
  const [rowData,setRowData] = useState()
  const toggleThreshold = () => setIsThresholdModal(!isThresholdModal);
  const toggleEditThreshold = () => setEditThresholdModal(!editThresholdModal);
  const toggleConfrimModal = () => setConfirmModal(!confirmModal);
  const table = useRef();
  const alert = useRef();
  const brandSelect = useRef();
  const cardTypeSelect = useRef();
  const [warningModal, setWarningModal] = useState(false);
  const toggleWarning = () => setWarningModal(!warningModal);
  const inventoryCtl = useMemo(() => new Inventory(token), [token]);
  const brandsCtl = new Brand(token)
  const [addInventoryLoading , setAddInventoryLoading] = useState(false)
  useEffect(() => {
    brandsCtl.all((data) => {
      if (data && !data.error) {
        const options = data?.result?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setBrandOption(options);
      }
    });
  }, []);

  useEffect(() => {
    inventoryCtl.getAll((data) => {
      if (data && !data.error) {
        setAllBrandData(data);
      }
    });
  }, []);

  useEffect(() => {
    setTableData(
      allBrandData.map((i) => ({
        id: i?.id,
        brandId: i?.brandId,
        brandName: i?.brandName,
        giftCardTypeId: i?.giftCardTypeId,
        giftCardTypeName: i?.giftCardTypeName,
        currencyId: i?.currencyId,
        currencyName: i?.currencyName,
        threshold: i?.threshold,
      }))
    );
  }, [allBrandData]);

  useEffect(() => {
    if (table.current) {
      table.current.dataTable.clear().rows.add(tableData).draw();
    }
  }, [tableData]);

  const thresholdOrder = () => {
    if (
      accessRoles.includes("PRODUCT_MANAGER") ||
      accessRoles.includes("ACCOUNTANT_MANAGER") ||
      accessRoles.includes("COMMERCIAL_MANAGER") ||
      accessRoles.includes("CUSTOMER_SERVICE")
    ) {
      toggleWarning();
      return;
    }
    toggleThreshold();
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setThresholdValue(value);
  };

  const handleBrandChange = (e) => {
    const brandId = e.value;
    const brandname = e.label;
    
    // Clear denomination dropdown when brand changes
    setCardTypeId(null);
    setCardTypeName(null);
    if (cardTypeSelect.current) {
      cardTypeSelect.current.clearValue();
    }
  
    setBrandId(brandId);
    setBrandName(brandname);
    setBrandValue(e);
    setCardsLoading(true);
  
    inventoryCtl.denomination(brandId, (data) => {
      if (data && !data.error) {
        const fixedCard = data.filter((item) => item.amount > 0);
        const cardoption = fixedCard.map((card) => ({
          value: card.id,
          label: card.productName,
        }));
        setCardTypes(cardoption);
        let currencyData = data?.length > 0 && data[0]?.currency;
        let currencyID = data?.length > 0 && data[0]?.currencyId;
  
        if (currencyData !== false) {
          setCurrency(currencyData);
        } else {
          setCurrency("");
        }
        
        setCurrencyId(currencyID);
      } else {
        if (cardTypeSelect.current) {
          cardTypeSelect.current.clearValue();
        }
        setCardTypes([]); // Clear options if no data returned
      }
    });
  };
  
  const handleCardTypeChange = (selectedOption) => {
    const value = selectedOption?.value;
    const name = selectedOption?.label;
    setCardTypeId(value);
    setCardTypeName(name);
  };

  const createInventory=()=>{
      setTimeout(()=>{
        setAddInventoryLoading(false)
      }, 1500)
    
  }

  const addtoThreshold = () => {
    setAddInventoryLoading(true)
   if(((brandName === null)|| (brandName === undefined)) && cardTypeId === undefined && currency === "" && thresholdValue === undefined){
     Notify(alert,"danger","All fields are required");
     createInventory()
     return;
    }
    let thresObj = {
      brandId: brandId,
      brandName: brandName,
      giftCardTypeId: cardTypeId,
      giftCardTypeName: cardTypeName,
      currencyId: currencyId,
      currencyName: currency,
      threshold: thresholdValue,
    };
    inventoryCtl.createThreshold(thresObj, (data) => {
      if (data && !data.error) {
        const newBrand = {
          id: data?.id,
          brandId: data?.brandId,
          brandName: data?.brandName,
          giftCardTypeId: data?.giftCardTypeId,
          giftCardTypeName: data?.giftCardTypeName,
          currencyId: data?.currencyId,
          currencyName: data?.currencyName,
          threshold: data?.threshold,
        };
       // setTableData([...tableData, newBrand]);
        toggleThreshold();
        setBrandValue({});
        setCurrency("");
        setThresholdValue();
        setBrandName();
          setBrandId();
          setCurrencyId();
          setCurrency("");
          setCardTypeId();
          setCardTypeName('')
        inventoryCtl.getAll((data) => {
          if (data && !data.error) {
            setAllBrandData(data);
          }
        });
        Notify(alert, "success", "Threshold added successfully");
        createInventory()
      } else {
        Notify(alert, "danger",  data.errorMessage ?? data.error );
        createInventory()
      }
    });
  };

  const editThreshold = (row) => {
    const rowData = row.data();
    const brand = {
      value: rowData.brandId,
      label: rowData.brandName,
    };
    setBrandId(rowData.brandId);
    setBrandValue(brand);
    setBrandName(rowData.brandName)
    const gifttcard = {
      value: rowData?.giftCardTypeId,
      label: rowData?.giftCardTypeName,
    };
    setCardTypeId(rowData?.giftCardTypeId);
    setGiftCardValue(gifttcard);
    setCurrency(rowData.currencyName);
    setCurrencyId(rowData?.currencyId);
    setThresholdValue(rowData.threshold);
    toggleEditThreshold();
  };
const deleteThresholdValue = (row) =>{
  setRowData(row)
  toggleConfrimModal();
}
  const deleteThreshold = async () => {
    setAddInventoryLoading(true)
    const Id = rowData.data().id;
    await inventoryCtl.deleteThreshold(Id, (data) => {
      if (data && !data.error) {
        rowData.remove().draw();
        setTableData(table.current.dataTable.rows().data().toArray());
        Notify(alert, "success", "Threshold Delete Successfully");
        createInventory()
        toggleConfrimModal();
      } else {
        Notify(alert, "danger",  data.errorMessage ?? data.error );
        createInventory()
      }
    });
  };

  const updateThreshold = () => {
    setAddInventoryLoading(true)
    let updateObj = {
      brandId: brandId,
      brandName: brandName,
      giftCardTypeId: cardTypeId,
      giftCardTypeName: cardTypeName,
      currencyId: currencyId,
      currencyName: currency,
      threshold: thresholdValue,
    };

    inventoryCtl.updateThreshold(updateObj, (data) => {
      if (data && !data.error) {
        const UpdateBrand = {
          id: data?.id,
          brandId: data?.brandId,
          brandName: data?.brandName,
          giftCardTypeId: data?.giftCardTypeId,
          giftCardTypeName: data?.giftCardTypeName,
          currencyId: data?.currencyId,
          currencyName: data?.currencyName,
          threshold: data?.threshold,
        };

        const rowIndex = tableData.findIndex((item) => item.id === data.id);

        if (rowIndex !== -1) {
          tableData[rowIndex] = UpdateBrand;

          if (table.current) {
            table.current.dataTable.clear().rows.add(tableData).draw();
          }
        }
        inventoryCtl.brands((data) => {
          if (data && !data.error) {
            const options = data?.map((item) => ({
              value: item.id,
              label: item.name,
            }));
            setBrandOption(options);
          }
        });

        toggleEditThreshold();
        setThresholdValue();
        setBrandName();
          setBrandId();
          setCurrencyId();
          setCurrency("");
          setCardTypeId();
          setCardTypeName('')
        Notify(alert, "success", "Threshold Update Successfully");
        createInventory()
      } else {
        Notify(alert, "danger",  data.errorMessage ?? data.error );
        createInventory()
      }
    });
  };

  return (
    <>
     <NotificationAlert ref={alert} />
      <div className="content">
        {/* Button Row */}
        <Row>
          <Col md="12">
            <Card>
              <CardHeader className="d-flex justify-content-end">
                <Row>
                  <Col
                    md="auto"
                    style={{ display: "flex", justifyContent: "end" }}
                  >
                    <MotionButton
                      initial={{ x: "-500%", opacity: 0 }}
                      animate={{
                        x: 0,
                        opacity: 1,
                        transition: { delay: 0.4, duration: 0.5 },
                      }}
                      className="add_brand_purchase_order btn btn-primaryTwo"
                      onClick={thresholdOrder}
                    >
                      <i className="fas fa-shopping-cart" /> Create Inventory
                      Threshold
                    </MotionButton>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody>
                <div className="table-responsive">
                  <Datatable
                    ref={table}
                    columns={[
                      {
                        title: "Brand Name",
                        data: "brandName",
                        sortable: true,
                      },
                      {
                        title: "Gift Card Type",
                        data: "giftCardTypeName",
                        sortable: true,
                      },
                      {
                        title: "Currency",
                        data: "currencyName",
                        sortable: true,
                      },
                      { title: "Threshold", data: "threshold", sortable: true },
                    ]}
                    data={tableData}
                    options={{
                      order: [[0, "desc"]],
                      saveState: false,
                      dom: "tip",
                    }}
                    addEditButton={{ callback: editThreshold, viewMode: false }}
                    addRemoveButton={{
                      callback: deleteThresholdValue,
                      viewMode: false,
                    }}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <Modal
        isOpen={isThresholdModal}
        toggle={toggleThreshold}
        backdrop="static"
        centered={true}
        size="xl"
        style={{ maxWidth: "85% !important" }}
      >
        <ModalHeader
          toggle={() => {
            toggleThreshold();
            setBrandValue({});
            setCurrency("");
            setThresholdValue();
          }}
          className="custom_header_colourTwo"
        >
          Create Inventory Threshold
        </ModalHeader>
        <ModalBody>
          <Row className="justify-content-center mt-5">
            <Col md={6}>
              <FormGroup>
                <Label for="purchaseFormBrand">Brand<span className="required-asterisk">*</span></Label>
                <Select
                  id="purchaseFormBrand"
                  ref={brandSelect}
                  value={Object.keys(brandValue).length === 0 ? null : brandValue}
                  options={brandOption}
                  onChange={handleBrandChange}
                  placeholder="Select..."
                  // isLoading={brandsLoading}
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="purchaseFormCurrency">Currency<span className="required-asterisk">*</span></Label>
                <Input
                  id="purchaseFormCurrency"
                  type="text"
                  name="currency"
                  placeholder="Enter Currency"
                  value={currency}
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="purchaseFormCardType">Denomination<span className="required-asterisk">*</span></Label>
                <Select
                  id="purchaseFormCardType"
                  ref={cardTypeSelect}
                  options={cardTypes}
                  onChange={handleCardTypeChange}
                  // isLoading={cardsLoading}
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="threshold">Threshold<span className="required-asterisk">*</span></Label>
                <Input
                  id="threshold"
                  type="number"
                  name="Threshold"
                  placeholder="Enter Threshold"
                  value={thresholdValue}
                  onChange={(e) => handleChange(e)}
                />
              </FormGroup>
            </Col>

            {/* <Col md='auto'>
					<FormGroup className="mt-1">
						
					</FormGroup>
				</Col> */}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            id="add-btn"
            type="button"
            className="btn btn-primaryTwo"
            onClick={addtoThreshold}
            disabled={addInventoryLoading}
          >
           {!addInventoryLoading && "Add"}{addInventoryLoading && 
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                style={{
                  margin: "0px 8px"
                }}
      />}
          </Button>
          <Button
            type="button"
            color="secondary"
            className="mr-3"
            onClick={() => {
              toggleThreshold();
              setBrandValue({});
              setCurrency("");
              setThresholdValue();
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={editThresholdModal}
        toggle={toggleEditThreshold}
        backdrop="static"
        centered={true}
        size="xl"
        style={{ maxWidth: "85% !important" }}
      >
        <ModalHeader
          toggle={() => {
            toggleEditThreshold();
            setBrandValue({});
            setCurrency("");
            setGiftCardValue({});
            setThresholdValue();
          }}
          className="custom_header_colourTwo"
        >
          Update Inventory Threshold
        </ModalHeader>
        <ModalBody>
          <Row className="justify-content-center mt-5">
            <Col md={6}>
              <FormGroup>
                <Label for="purchaseFormBrand">Brand<span className="required-asterisk">*</span></Label>
                <Select
                  id="purchaseFormBrand"
                  ref={brandSelect}
                  value={brandValue}
                  options={brandOption}
                  onChange={handleBrandChange}
                  isDisabled={true}
                  // isLoading={brandsLoading}
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="purchaseFormCurrency">Currency<span className="required-asterisk">*</span></Label>
                <Input
                  id="purchaseFormCurrency"
                  type="text"
                  name="currency"
                  placeholder="Enter Currency"
                  value={currency}
                  disabled
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="purchaseFormCardType">Denomination<span className="required-asterisk">*</span></Label>
                <Select
                  id="purchaseFormCardType"
                  ref={cardTypeSelect}
                  options={cardTypes}
                  value={giftCardValue}
                  onChange={handleCardTypeChange}
                  isDisabled={true}
                  // isLoading={cardsLoading}
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="threshold">Threshold<span className="required-asterisk">*</span></Label>
                <Input
                  id="threshold"
                  type="number"
                  name="Threshold"
                  placeholder="Enter Threshold"
                  value={thresholdValue}
                  onChange={(e) => handleChange(e)}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn btn-primaryTwo"
            id="add-btn"
            type="button"
            
            onClick={updateThreshold}
            disabled={addInventoryLoading}
          >
            {!addInventoryLoading && "Update"}{addInventoryLoading && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}
          </Button>
          <Button
            type="button"
            color="secondary"
            className="mr-3"
            onClick={() => {
              toggleEditThreshold();
              setBrandValue({});
              setCurrency("");
              setGiftCardValue({});
              setThresholdValue();
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={warningModal} toggle={toggleWarning} backdrop="static">
        <ModalHeader className="bg-warning" toggle={toggleWarning}>
          Access Denied
        </ModalHeader>
        <ModalBody>
          <p className="card-just-text">
            You do not have access to perform this action
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleWarning}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={confirmModal} toggle={toggleConfrimModal} backdrop="static" centered>
          <ModalHeader className="custom_header_colourTwo" toggle={toggleConfrimModal}>Confirm Delete threshold</ModalHeader>
          <ModalBody>
            <p style={{fontSize:"22px",fontWeight:"600"}}>
              Do you want to delete this threshold 
              {/* Do you want to cancel the order? */}
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleConfrimModal}>Close</Button>
            <Button  className="btn btn-primaryTwo" onClick={deleteThreshold} disabled={addInventoryLoading}>{!addInventoryLoading && "Confirm"}{addInventoryLoading && <Spinner
        as="span"
        animation="border"
        size="sm"
        role="status"
        aria-hidden="true"
        style={{
          margin: "0px 8px"
        }}
      />}</Button>
          </ModalFooter>
			</Modal>
    </>
  );
};

export default ThresholdInventory;
